import { motion } from "framer-motion";
import { WhatDoesThisMean } from "../shared/WhatDoesThisMean";

export function ProjectionsCard({ projections, monthsOfData }) {
  const items = [
    { label: "3 Months", value: projections["3_month"] },
    { label: "6 Months", value: projections["6_month"] },
    { label: "12 Months", value: projections["12_month"] },
  ];
  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.2 }} className="bg-igc-surface border border-igc-gold/15 p-6 h-full" data-testid="business-projections-card">
      <p className="text-igc-muted text-xs uppercase tracking-widest mb-6">
        Business Projections
        <WhatDoesThisMean
          testId="projections-explainer"
          text="These are IGC's best-guess estimates of your future revenue based on how your store is trending right now. They're a forecast, not a guarantee — actual results can be higher or lower."
        />
      </p>
      <div className="grid grid-cols-3 gap-4">
        {items.map((item) => (
          <div key={item.label} className="border border-igc-success/15 p-4 text-center hover:-translate-y-0.5 transition-transform" data-testid={`projection-${item.label.replace(" ", "-").toLowerCase()}`} title={`IGC's best-guess forecast of your store's total revenue over the next ${item.label.toLowerCase()}, based on your current trajectory.`}>
            <p className="text-igc-muted text-xs mb-2">{item.label}</p>
            <p className="font-serif text-2xl text-igc-success">${item.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
          </div>
        ))}
      </div>
      {typeof monthsOfData === "number" && monthsOfData > 0 && monthsOfData < 6 && (
        <p className="text-igc-muted text-xs mt-4 font-medium" data-testid="projections-data-caveat">
          Based on {monthsOfData} month{monthsOfData === 1 ? "" : "s"} of store data — projections will firm up as more history accumulates.
        </p>
      )}
      <p className="text-igc-muted text-[11px] mt-2">Projections generated by IGC's proprietary platform based on current ramp trajectory.</p>
    </motion.div>
  );
}
